export interface FaqItem {
  id: string;
  group: string;
  question: string;
  answer: string;
}

export interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

export interface StatItem {
  value: string;
  label: string;
  sub: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  text: string;
  tag: string;
}

export interface FeedItem {
  id: string;
  title: string;
  category: string;
  time: string;
  heat: string;
  liveId: string;
}

export interface PrincipleItem {
  index: string;
  title: string;
  desc: string;
}

export interface MilestoneItem {
  year: string;
  title: string;
  desc: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "faq-1",
    group: "观看与信号",
    question: "爆料直播的画面是实时的吗，会有延时吗？",
    answer:
      "大部分现场采用实时画面信号直传，从现场采集到页面呈现通常只有数秒级延时。少数山区、地下或移动中的拍摄点位会先经过一次中继转发，以保证画面不中断，这类直播会在详情页标注信号状态。",
  },
  {
    id: "faq-2",
    group: "观看与信号",
    question: "为什么有些直播只有画面没有声音？",
    answer:
      "当现场涉及当事人隐私、正在进行的救援指挥，或者环境噪声会干扰判断时，信号组会主动关闭声音，只保留画面。你可以在详情页看到声音开关的状态说明，这类直播仍会保留连麦音频片段供回看。",
  },
  {
    id: "faq-3",
    group: "观看与信号",
    question: "直播卡顿或者画面加载不出来怎么办？",
    answer:
      "先确认当前网络是否稳定，切换 Wi-Fi 与移动网络各试一次；也可以在详情页点击重新接入信号。若同一场直播持续无法加载，通常说明该路信号正在进行设备切换，稍等两三分钟后刷新即可恢复。",
  },
  {
    id: "faq-4",
    group: "观看与信号",
    question: "回看内容会保留多久？",
    answer:
      "正在直播的场次结束后会自动转为回看，常规内容保留 90 天。涉及公共安全、极端天气与重大事故的现场档案，会做长期存档并标注时间点，方便之后核对现场情况。",
  },
  {
    id: "faq-5",
    group: "连麦与投稿",
    question: "我想进入直播间连麦讲述经过，需要什么条件？",
    answer:
      "只要你本人是当事人或直接目击者即可申请。请在现场信息页留下可联系的邮箱与简述，编辑组会先做一次简短核实，确认身份与时间地点后安排连麦时段。我们不接受转述他人说法或以情绪表达为主的连麦。",
  },
  {
    id: "faq-6",
    group: "连麦与投稿",
    question: "手上有现场视频或照片，怎么提交给爆料直播？",
    answer:
      "请勿在公开评论区直接发布原文件。你可以通过页面上的投稿邮箱说明素材的时间、地点与拍摄者身份，编辑组确认后会回复安全的提交方式。我们只在核实素材来源后使用，并会对个人信息做模糊处理。",
  },
  {
    id: "faq-7",
    group: "连麦与投稿",
    question: "投稿之后多久会收到回复？",
    answer:
      "工作时段内的投稿通常在 4 小时内答复。如果素材对应的现场正在直播，编辑组会优先处理，并可能邀请你直接进入连麦。未采用的素材我们也会说明原因，并默认不再保留原始文件。",
  },
  {
    id: "faq-8",
    group: "内容与版权",
    question: "爆料直播的内容原则是什么？",
    answer:
      "我们坚持呈现画面本身，不替当事人下结论，不对现场做情绪化渲染。涉及未成年人、伤者与逝者的画面会做必要处理；未经核实的说法会明确标注为待确认。所有直播都会保留时间戳，方便回溯。",
  },
  {
    id: "faq-9",
    group: "内容与版权",
    question: "可以和你们的内容合作或转载吗？",
    answer:
      "欢迎媒体与机构在保留原始时间戳与来源标注的前提下申请转载。请通过页面底部邮箱说明用途、渠道与预计发布时间，我们会在确认使用范围后给出授权答复。未获授权的剪辑拼接属于侵权。",
  },
  {
    id: "faq-10",
    group: "内容与版权",
    question: "发现内容有误，如何反馈更正？",
    answer:
      "如果你认为某场直播的画面或描述与事实不符，请发送邮件并附上可核实的依据。编辑组会在核实后于原直播详情页顶部添加更正说明，保留原内容并标注修改时间，不做静默删除。",
  },
];

export const platformFeatures: FeatureItem[] = [
  {
    icon: "ri-live-line",
    title: "现场实时画面",
    desc: "信号组直接在点位架设机位，画面从现场传到页面通常只有数秒延时，不做二次摆拍。",
  },
  {
    icon: "ri-signal-tower-line",
    title: "信号稳定优先",
    desc: "每路直播都有主备两条回传通道，弱网环境自动降码率保流畅，宁可略降清晰度也不断流。",
  },
  {
    icon: "ri-mic-2-line",
    title: "现场连麦声音",
    desc: "把当事人、目击者请进直播间直接说话，保留语气与停顿，让经过由声音自己讲清楚。",
  },
  {
    icon: "ri-radar-line",
    title: "直播镜头追踪",
    desc: "事态推进到哪一步，镜头就跟到哪一步；从现场到后续处置，形成连续而不是切片式的记录。",
  },
];

export const stats: StatItem[] = [
  { value: "1,240+", label: "累计现场场次", sub: "覆盖全国 30 余个城市片区" },
  { value: "12", label: "同时在线信号", sub: "主备双通道回传" },
  { value: "3.2 亿", label: "累计观看人次", sub: "含回看与连麦片段" },
  { value: "98%", label: "信号稳定率", sub: "近一年直播未中断占比" },
];

export const testimonials: TestimonialItem[] = [
  {
    name: "老陈",
    role: "本地社区居民",
    text: "我们楼道加装电梯那场，从发言到投票全程都在直播，谁说了什么一清二楚，比事后听人转述靠谱多了。",
    tag: "民生追踪",
  },
  {
    name: "阿泽",
    role: "夜班通勤族",
    text: "早高峰看地铁口的积水直播，直接决定要不要绕路，画面里连水位刻度都看得见，比文字播报直观。",
    tag: "城市路况",
  },
  {
    name: "小满",
    role: "高校学生",
    text: "喜欢的是连麦环节，当事人自己讲，声音里能听出情绪，但主持人不会带节奏，这点挺难得的。",
    tag: "现场连麦",
  },
  {
    name: "刘工",
    role: "应急救援志愿者",
    text: "暴雨那场我们从冲锋舟视角看转移进度，物资清单一箱一箱核对，画面没经过修饰，反而是最有用的信息。",
    tag: "事故直击",
  },
];

export const hotFeed: FeedItem[] = [
  {
    id: "hot-1",
    title: "城北自建房搬迁进入最后一夜，巷口机位未切",
    category: "突发现场",
    time: "3 分钟前",
    heat: "128.4 万",
    liveId: "live-001",
  },
  {
    id: "hot-2",
    title: "台风外围云系压境，老码头封港画面持续回传",
    category: "天气预警",
    time: "11 分钟前",
    heat: "96.4 万",
    liveId: "live-002",
  },
  {
    id: "hot-3",
    title: "夜市中心起争执，双方连麦还原全过程",
    category: "民生追踪",
    time: "27 分钟前",
    heat: "74.2 万",
    liveId: "live-003",
  },
  {
    id: "hot-4",
    title: "三号线出站口积水，排水车作业水位刻度对比",
    category: "城市路况",
    time: "42 分钟前",
    heat: "58.9 万",
    liveId: "live-004",
  },
  {
    id: "hot-5",
    title: "绕城高速 K112 多车追尾，清障车按序拖离",
    category: "事故直击",
    time: "1 小时前",
    heat: "41.2 万",
    liveId: "live-005",
  },
  {
    id: "hot-6",
    title: "山火过境首夜，12 个值守点排查余火回看",
    category: "突发现场",
    time: "2 小时前",
    heat: "21.1 万",
    liveId: "live-007",
  },
  {
    id: "hot-7",
    title: "演唱会散场四出口人流密度同屏对比",
    category: "现场连麦",
    time: "3 小时前",
    heat: "28.9 万",
    liveId: "live-010",
  },
  {
    id: "hot-8",
    title: "凌晨批发市场到货量播报，叶菜价格逐项更新",
    category: "民生追踪",
    time: "4 小时前",
    heat: "6.3 万",
    liveId: "live-012",
  },
];

export const principles: PrincipleItem[] = [
  {
    index: "01",
    title: "画面先于结论",
    desc: "先让画面说话，再谈判断。我们不抢在事实之前下定义，把现场原貌完整交给观看者。",
  },
  {
    index: "02",
    title: "保持镜头在场",
    desc: "事态推进到哪一步，镜头就跟到哪一步。避免只截取最有冲击力的几秒，形成连续记录。",
  },
  {
    index: "03",
    title: "不渲染情绪",
    desc: "不配煽情音乐，不加快剪慢放，不用夸张标题。声音保留原声，让语气本身成为信息。",
  },
  {
    index: "04",
    title: "尊重当事人",
    desc: "涉及未成年人、伤者与普通居民的镜头会做必要处理；未经核实的说法一律标注为待确认。",
  },
];

export const milestones: MilestoneItem[] = [
  {
    year: "2021",
    title: "从一台信号车开始",
    desc: "最初只有一辆改装信号车和一条回传链路，在暴雨夜里第一次把积水路段的画面完整送了出去。",
  },
  {
    year: "2022",
    title: "主备双通道成型",
    desc: "搭建双通道回传与自动降码率机制，信号中断率明显下降，直播从偶尔尝试变成常态值守。",
  },
  {
    year: "2024",
    title: "连麦成为固定环节",
    desc: "把当事人请进直播间直接说话，与画面互相印证，逐渐形成「镜头 + 声音」的双线呈现方式。",
  },
  {
    year: "2026",
    title: "12 路信号同时在线",
    desc: "现场点位扩展到 30 余个城市片区，形成覆盖突发事件、城市路况与民生现场的直播网络。",
  },
];

export const viewingRules: string[] = [
  "直播画面含现场原声，观看时请适当调低音量，避免惊扰他人。",
  "涉及未成年人、伤者与逝者的画面已做必要处理，请勿二次剪辑传播。",
  "评论区请围绕现场事实讨论，不发布未经核实的当事人信息。",
  "如需引用直播内容，请保留原始时间戳与来源标注。",
];

